class SoundManager {
  constructor() {
    this.sounds = {};
    this.muted = localStorage.getItem('soundMuted') === 'true';
    this.initialized = false;
  }

  init() {
    if (this.initialized) return;
    
    this.sounds = {
      hero_whoosh: new Audio('/sounds/ui_hero_whoosh.mp3'),
      tab_click: new Audio('/sounds/ui_tab_click.mp3'),
      modal_reveal: new Audio('/sounds/ui_modal_reveal.mp3')
    };

    // Set volumes
    if (this.sounds.hero_whoosh) this.sounds.hero_whoosh.volume = 0.6;
    if (this.sounds.tab_click) this.sounds.tab_click.volume = 0.4;
    if (this.sounds.modal_reveal) this.sounds.modal_reveal.volume = 0.7;

    this.initialized = true;
  }

  play(soundName) {
    if (this.muted) return;
    if (!this.initialized) this.init();
    
    const sound = this.sounds[soundName];
    if (sound) {
      sound.currentTime = 0;
      sound.play().catch(err => console.log('Sound play prevented:', err));
    }
  }

  toggleMute() {
    this.muted = !this.muted;
    localStorage.setItem('soundMuted', this.muted);
    return this.muted;
  }

  isMuted() {
    return this.muted;
  }
}

export const soundManager = new SoundManager();
